var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},[_c('Offer',{attrs:{"isVta":_vm.isVta,"onSubmit":_vm.submit,"placement":_vm.placement}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }